import { GoHeart, GoHeartFill } from "react-icons/go";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import {
  selectFavorites,
  selectTogglingProductId,
  toggleFavorite,
} from "../redux/slices/favoritesSlice";
import { useDispatch, useSelector } from "react-redux";

import BingLoader from "../components/Loader/BingLoader";
import { FaCheck } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { FaTruckFast } from "react-icons/fa6";
import { Helmet } from "react-helmet";
import LoaderMini from "../components/Loader/LoaderMini";
import MiniLoader from "../components/Loader/MiniLoader";
import MultiSectionAddons from "../components/MultiSectionAddons/MultiSectionAddons";
import PersonalizationPopup from "../components/PersonalizationPopup/PersonalizationPopup";
import ProductGallery from "../components/ProductGallery/ProductGallery";
import RelatedProducts from "../components/RelatedProducts/RelatedProducts";
import { addItemToCart } from "../redux/slices/cartSlice";
import americanExpress from "../assets/images/amircanexpress.jpg";
import { fetchCards } from "../redux/slices/cardsSlice";
import { fetchProductDetails } from "../redux/slices/productDetailsSlice";
import googlePay from "../assets/images/googlepay.jpg";
import mada from "../assets/images/mada.png";
import master from "../assets/images/master.png";
import pay from "../assets/images/pay.png";
import stcPay from "../assets/images/stcpay.jpg";
import tamara from "../assets/icons/tamara.png";
import { trackGoogleConversion } from "../utils/GoogleAdsPixel";
import { trackMetaEvent } from "../utils/MetaPixel";
import { trackSnapEvent } from "../utils/SnapPixel";
import { trackTikTokEvent } from "../utils/TiktokPixel";
import { triggerGTMEvent } from "../utils/gtm";
import { useTranslation } from "react-i18next";
import visa from "../assets/images/visa.png";

// import { trackEvent } from "../analytics";








const Product = () => {
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  const isEng = i18n.language === "en";
  const { productId } = useParams();
  const [quantity, setQuantity] = useState(1);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [message, setMessage] = useState("");
  const [link, setLink] = useState("");
  const [uploadvideo, setUploadVideo] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [err, setErr] = useState("");
  const [showLinkInput, setShowLinkInput] = useState(false);
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  // const [added, setAdded] = useState(false);
  const [done, setDone] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [videoErr, setVideoErr] = useState("");
  const [showPersonalizationPopup, setShowPersonalizationPopup] =
    useState(false);

  const {
    cards,
    loading: cardLoading,
    error: cardError,
  } = useSelector((state) => state.cards);

  // New states for upload progress monitoring
  const [videoUploadProgress, setVideoUploadProgress] = useState(0);
  const [thumbnailUploadProgress, setThumbnailUploadProgress] = useState(0);
  const [isVideoUploading, setIsVideoUploading] = useState(false);
  const [isThumbnailUploading, setIsThumbnailUploading] = useState(false);
  const [cardsList, setCardsList] = useState([]);
  const [selectedSection, setSelectedSection] = useState("desc");
  const [selectedCardDesign, setSelectedCardDesign] = useState(null);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const { product, loading, error } = useSelector(
    (state) => state.productDetails
  );
  const favorites = useSelector(selectFavorites) || [];

  const isFavorite = favorites.some((fav) => fav.product_id === product?.id);
  const togglingProductId = useSelector(selectTogglingProductId);
  const isToggling = togglingProductId === productId;

  const handleToggleFavorite = (productId) => {
    dispatch(toggleFavorite(productId));
  };

  const { categories } = useSelector((state) => state.categories);

  const category = categories.find((cat) => cat.id === product?.category_id);

  useEffect(() => {
    dispatch(fetchCards());
  }, [dispatch]);

  useEffect(() => {
    if (cards.length > 0 && !cardLoading) {
      setCardsList(cards);
      setSelectedCardDesign(cards[0]);
      setCurrentCardIndex(0);
    }
  }, [cards, cardLoading]);

  useEffect(() => {
    if (productId) {
      dispatch(fetchProductDetails(productId));
    }
  }, [dispatch, productId]);

  const handleAddonChange = (addon, isChecked) => {
    if (isChecked) {
      setSelectedAddons([
        ...selectedAddons,
        {
          id: addon.id,
          price: addon.price,
          quantity: 1,
        },
      ]);
    } else {
      setSelectedAddons(selectedAddons.filter((item) => item.id !== addon.id));
    }
  };

  const handleShowLinkInput = () => {
    setShowLinkInput((prev) => !prev);
  };

  const handleAddonQuantityChange = (addonId, quantity) => {
    setSelectedAddons(
      selectedAddons.map((addon) =>
        addon.id === addonId ? { ...addon, quantity } : addon
      )
    );
  };

  const handleVideoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    console.log("Video file selected:", file); // Debug to verify file object
    const MAX_FILE_SIZE = 2 * 1024 * 1024; // 50MB in bytes
    if (file.size > MAX_FILE_SIZE) {
      setVideoErr(
        "Video file is too large. Please upload a file smaller than 2MB."
      );
      return;
    }

    // Check file type
    if (!file.type.startsWith("video/")) {
      setVideoErr("Please upload a valid video file.");
      return;
    }

    setUploadVideo(file);
    simulateFileUpload(file, setVideoUploadProgress, setIsVideoUploading);
    setVideoErr("");
  };

  const handleThumbnailUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setThumbnail(file);

    simulateFileUpload(
      file,
      setThumbnailUploadProgress,
      setIsThumbnailUploading
    );
  };

  const simulateFileUpload = (file, setProgress, setIsUploading) => {
    setProgress(0);
    setIsUploading(true);

    const totalTime = Math.min(Math.max(file.size / 100000, 2), 10) * 1000;
    const intervalTime = 100;
    const steps = totalTime / intervalTime;
    let currentStep = 0;

    const interval = setInterval(() => {
      currentStep++;
      const newProgress = Math.min(Math.round((currentStep / steps) * 100), 99);
      setProgress(newProgress);

      if (currentStep >= steps) {
        clearInterval(interval);
        setProgress(100);

        setTimeout(() => {
          setIsUploading(false);
        }, 500);
      }
    }, intervalTime);
  };

  const navigate = useNavigate();

  const handleAddToCart = () => {
    setIsLoading(true);

    const itemData = {
      user_id: user?.id,
      product_id: product.id,
      quantity,
      price: product.price,
      addons: selectedAddons,
      message,
      link,
    };
    if (!isAuthenticated) {
      itemData.product = product;
    }

    if (selectedCardDesign) {
      itemData.card_id = selectedCardDesign.id;
      itemData.card_image = selectedCardDesign.website_image;
    }

    if (uploadvideo) {
      itemData.uploadvideo = uploadvideo;
    }

    if (thumbnail) {
      itemData.thumbnail = thumbnail;
    }

    dispatch(addItemToCart(itemData))
      .unwrap()
      .then(() => {
        if (product) {
       
          triggerGTMEvent("add_to_cart", {
            product_id: product.id,
              product_name: product.english_name,
              product_quantity: quantity,
              product_price: product.price,
              user_id: user?.id,
              name: user?.name,
              email: user?.email,
              phone_number: user?.phone,
              currency: "SAR",
              addons: selectedAddons.map((addon) => ({
                addon_id: addon.id,
                quantity: addon.quantity,
                price: addon.price,
              })),
          });
        }

        trackMetaEvent('AddToCart');
        trackTikTokEvent('AddToCart');
        trackSnapEvent('ADD_CART');
        trackGoogleConversion({ sendTo: process.env.REACT_APP_GOOGLE_CONVERSION_ATC });
        trackGoogleConversion({ sendTo: process.env.REACT_APP_GOOGLE_CONVERSION_CART });


        setDone(true);
        setIsLoading(false);
        // setAdded(true);
        setSelectedAddons([]);
        setTimeout(() => {
          setDone(false);
        }, 5000);
        setLink("");
        setMessage("");
        setQuantity(1);
        setUploadVideo(null);
        setThumbnail(null);
        setVideoUploadProgress(0);
        setThumbnailUploadProgress(0);
        setShowLinkInput(false);
      })
      .catch((err) => {
        console.error("Add to cart error:", err);
        setErr(`Failed to add to cart: ${err.message || JSON.stringify(err)}`);
        setIsLoading(false);
      });
  };

  const hasTrackedViewProduct = useRef(false);

  useEffect(() => {
    if (product && !hasTrackedViewProduct.current) {
      hasTrackedViewProduct.current = true;

      triggerGTMEvent("view_product", {
        product_id: product.id,
        product_name: product.english_name,
        category: category?.english_name || "unknown",
        price: product.price,
        currency: "SAR",
        addons: selectedAddons.map((addon) => ({
          addon_id: addon.id,
          quantity: addon.quantity,
          price: addon.price,
        })),
        user_id: user?.id || "guest",
        user_name: user?.name || "guest",
        user_email: user?.email || "guest",
        user_phone: user?.phone || "guest",
      });
    }
  }, [product, category, selectedAddons, user]);

  const UploadProgressBar = ({ progress, isUploading, fileName }) => {
    if (!fileName) return null;

    return (
      <div className="w-full mt-2">
        <div className="flex justify-between mb-1">
          <span className="text-sm truncate max-w-[200px]">
            {fileName.name}
          </span>
          <span className="text-sm font-medium">{progress}%</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className={`h-2 rounded-full ${isUploading ? "bg-blue-600" : "bg-green-500"
              }`}
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <div className="text-xs mt-1 text-gray-500">
          {isUploading ? (
            <LoaderMini color="bg-purble-2" />
          ) : progress === 100 ? (
            t("uploadComplete")
          ) : (
            ""
          )}
        </div>
      </div>
    );
  };

  if (error) {
    return (
      <div className="p-8 text-red-500 flex items-center justify-center w-screen h-screen">
        {error}
      </div>
    );
  }
  if (err) {
    return (
      <div className="p-8 text-red-500 flex items-center justify-center w-screen h-screen">
        {err}
      </div>
    );
  }
  const base_url = process.env.REACT_APP_PRODUCTION_URL;

  return (
    <div className="flex flex-col items-start justify-center w-screen min-h-screen">
      <Helmet>
        <title>
          {isEng ? product?.seo_metas?.en?.title : product?.seo_metas?.ar?.title}
        </title>
        <meta name="description" content={isEng ? product?.seo_metas?.en?.description : product?.seo_metas?.ar?.description} />
        <meta name="keywords" content={isEng ? product?.seo_metas?.en?.keywords : product?.seo_metas?.ar?.keywords} />
        <meta name="robots" content={isEng ? product?.seo_metas?.en?.meta_robots : product?.seo_metas?.ar?.meta_robots} />

        <link rel="canonical" href={`${base_url}/categories/${isEng ? product?.seo_metas?.en?.slug : product?.seo_metas?.ar?.slug}`} />

        <meta property="og:title" content={isEng ? product?.seo_metas?.en?.og_title : product?.seo_metas?.ar?.og_title} />
        <meta property="og:description" content={isEng ? product?.seo_metas?.en?.og_description : product?.seo_metas?.ar?.og_description} />
      </Helmet>
      <div
        className="flex flex-col items-center justify-center w-full 
      px-5 py-10"
      >
        <div
          className="flex flex-col relative items-start justify-start
       w-[90%] gap-5 p-5 whitespace-nowrap"
        >
          <div className="text-base flex items-center justify-center gap-1">
            <Link
              to="/"
              className="hover:underline underline-offset-2 hover:text-blue-2"
            >
              <p>{t("home")} &gt;</p>
            </Link>
            <Link
              to={`/categories/${category?.id}`}
              className="hover:underline underline-offset-2 hover:text-blue-2"
            >
              <p>
                {i18n.language === "en"
                  ? category?.english_name
                  : category?.arabic_name}{" "}
                &gt;
              </p>
            </Link>
            <p>
              {i18n.language === "en"
                ? product?.english_name
                : product?.arabic_name}
            </p>
          </div>
        </div>
        {loading ? (
          <div className="flex items-center justify-center w-full h-full">
            <MiniLoader />
          </div>
        ) : !product ? (
          <div className="flex items-center justify-center w-screen h-screen text-lg text-red-500">
            Product Not Found yet
          </div>
        ) : (
          <div className="flex w-full flex-col items-center">
            <div
              className="flex flex-col lg:flex-row items-center lg:items-start 
          justify-center w-full gap-5"
            >
              {/* Product Image */}
              <ProductGallery
                images={product?.gallery}
                ar_name={product?.arabic_name}
                en_name={product?.english_name}
              />
              {/* Product Details */}
              <div
                className="w-[20rem] lg:w-[34.25rem] lg:px-5 py-3 flex
              flex-col items-start justify-start"
              >
                <p className="text-5xl font-semibold mb-4">
                  {product?.price} {i18n.language === "en" ? "SAR" : "ر.س"}
                </p>
                <div className="flex w-full justify-between items-start">
                  <div className="flex gap-1 items-start whitespace-nowrap">
                    <h1 className="text-xl lg:text-2xl font-bold mb-4">
                      {i18n.language === "en"
                        ? product?.english_name
                        : product?.arabic_name}
                    </h1>
                    {product?.num > 0 && (
                      <div
                        className="flex text-lg lg:text-2xl
                  w-full justify-start items-center gap-2 mb-4 font-bold"
                      >
                        <p>|{product?.num}</p>
                        <p>{t("flowers")}</p>
                      </div>
                    )}
                  </div>
                  <Link to={`/categories/${category?.id}`}>
                    <div className="lg:text-2xl text-lg text-gray-2/70 mb-3 hover:text-blue-500 ">
                      {i18n.language === "en"
                        ? category?.english_name
                        : category?.arabic_name}
                    </div>
                  </Link>{" "}
                </div>

                {/* Add to Cart Button */}
                <div
                  className="flex items-center justify-between 
                lg:justify-start w-full gap-3 mb-5"
                >
                  <button
                    className="px-3 h-[58px] bg-purble-2 text-white 
  rounded-full hover:bg-purble-2/90 transition
   w-[80%] lg:w-[85%] text-sm lg:text-base"
                    onClick={() => {
                      setShowPersonalizationPopup(true);
                    }}
                    disabled={isVideoUploading || isThumbnailUploading}
                  >
                    {isLoading ? (
                      <div className="flex items-center justify-center">
                        <LoaderMini color="bg-white" />
                      </div>
                    ) : done ? (
                      <div className="flex items-center justify-center gap-1">
                        <FaCheck />
                        <p>{t("added")}</p>
                      </div>
                    ) : isVideoUploading || isThumbnailUploading ? (
                      <p>{t("uploading")}...</p>
                    ) : (
                      <p>{t("addToCart")}</p>
                    )}
                  </button>
                  <button
                    type="button"
                    onClick={() => handleToggleFavorite(productId)}
                    className="flex items-center justify-center w-[58px]  h-[58px] border border-blue-900 rounded-full
                  transition-all ease-in-out flex-shrink-0"
                  >
                    {isToggling ? (
                      <BingLoader />
                    ) : isFavorite ? (
                      <GoHeartFill className="size-8 lg:size-6 text-red-500" />
                    ) : (
                      <GoHeart className="size-8 lg:size-6" />
                    )}
                  </button>
                </div>
                {/* info */}
                <div
                  className="flex flex-col w-full rounded-2xl border 
                 items-start mb-4"
                >
                  <div
                    className="flex items-center justify-start gap-5
                  border-b w-full p-2"
                  >
                    <div>
                      <FaLocationDot size={30} />
                    </div>
                    <div className="flex flex-col">
                      <p className="font-semibold text-lg">
                        {t("noAddressHassle")}
                      </p>
                      <p>{t("weWillCollect")}</p>
                    </div>
                  </div>
                  <div
                    className="flex items-center justify-start gap-5 w-full
                  p-2"
                  >
                    <div>
                      <FaTruckFast size={30} />
                    </div>
                    <div className="flex flex-col">
                      <p className="font-semibold text-lg">
                        {t("free_delivery")}
                      </p>
                      <p>{t("freeDeliveryMessage")}</p>
                    </div>
                  </div>
                </div>

                {/* ways to pay */}
                <div
                  className="flex w-full items-center justify-between rounded-2xl
                border p-3"
                >
                  <p className="text-xs lg:text-base">{t("waysToPay")}</p>
                  <div className="flex items-center justify-center gap-1">
                    <div>
                      <img
                        src={mada}
                        alt="mada"
                        className=" h-[18px] object-cover"
                      />
                    </div>
                    <div>
                      <img
                        src={tamara}
                        alt="tamara"
                        className=" h-[18px] object-cover"
                      />
                    </div>
                    <div>
                      <img
                        src={pay}
                        alt="pay"
                        className=" h-[18px] object-cover"
                      />
                    </div>
                    <div>
                      <img
                        src={master}
                        alt="master"
                        className=" h-[18px] object-cover"
                      />
                    </div>
                    <div>
                      <img
                        src={visa}
                        alt="visa"
                        className=" h-[18px] object-cover"
                      />
                    </div>
                    <div>
                      <img
                        src={googlePay}
                        alt="google_pay"
                        className=" h-[18px] object-cover"
                      />
                    </div>
                    <div>
                      <img
                        src={americanExpress}
                        alt="American Express"
                        className=" h-[18px] object-cover"
                      />
                    </div>
                    <div>
                      <img
                        src={stcPay}
                        alt="Stc_pay"
                        className=" h-[18px] object-cover"
                      />
                    </div>
                  </div>
                </div>
                {/* Addons */}
                <MultiSectionAddons
                  handleAddonChange={handleAddonChange}
                  selectedAddons={selectedAddons}
                  handleAddonQuantityChange={handleAddonQuantityChange}
                />
                {/* Personalization Options */}
                {showPersonalizationPopup && (
                  <PersonalizationPopup
                    onClose={() => setShowPersonalizationPopup(false)}
                    onConfirm={() => {
                      handleAddToCart();
                      setIsLoading(true);
                      setTimeout(() => {
                        setIsLoading(false);
                        setShowPersonalizationPopup(false);
                        navigate("/cart"); // optional: only if user clicks View Cart
                      }, 1000);
                    }}
                    {...{
                      message,
                      setMessage,
                      link,
                      setLink,
                      showLinkInput,
                      handleShowLinkInput,
                      uploadvideo,
                      handleVideoUpload,
                      videoUploadProgress,
                      isVideoUploading,
                      videoErr,
                      thumbnail,
                      handleThumbnailUpload,
                      thumbnailUploadProgress,
                      isThumbnailUploading,
                      selectedCardDesign,
                      setSelectedCardDesign,
                      cards: cardsList,
                      cardLoading,
                      cardError,
                      currentCardIndex,
                      setCurrentCardIndex,
                      UploadProgressBar,
                      isLoading,
                      done,
                      LoaderMini,
                      FaCheck,
                    }}
                  />
                )}
              </div>
            </div>
            <div className="flex flex-col items-center justify-center gap-10  py-5 w-[90%]">
              <div className="w-full items-center justify-center flex border-b border-blue-2 gap-5">
                <div
                  className="relative group flex items-center justify-center overflow-hidden 
            h-full font-semibold text-xl lg:text-3xl"
                >
                  <button
                    onClick={() => setSelectedSection("desc")}
                    className={`flex items-center justify-center gap-1 px-2 
              ease-in-out duration-100 h-full py-4 ${selectedSection === "desc"
                        ? " py-4 text-blue-2"
                        : " group-hover:py-4 text-gray-2 group-hover:text-blue-2"
                      }`}
                  >
                    <p className="">{t("description")}</p>
                  </button>
                  <span
                    className={`ease-in-out absolute bottom-0 h-1 rounded-t-full bg-purble-2
               duration-100 flex items-center justify-center ${selectedSection === "desc"
                        ? "w-full"
                        : "group-hover:w-full w-0"
                      }`}
                  ></span>
                </div>
                <div
                  className="relative group flex items-center justify-center overflow-hidden 
            h-full text-xl lg:text-3xl font-semibold"
                >
                  <button
                    onClick={() => setSelectedSection("care")}
                    className={`flex items-center justify-center gap-1 px-2 
              ease-in-out duration-100 h-full py-4 ${selectedSection === "care"
                        ? " py-4 text-blue-2"
                        : " group-hover:py-4 text-gray-2 group-hover:text-blue-2"
                      }`}
                  >
                    <p className="">{t("careTips")}</p>
                  </button>
                  <span
                    className={`ease-in-out absolute bottom-0 h-1 rounded-t-full bg-purble-2
               duration-100 flex items-center justify-center ${selectedSection === "care"
                        ? "w-full"
                        : "group-hover:w-full w-0"
                      }`}
                  ></span>
                </div>
              </div>
              {selectedSection === "care" ? (
                <div className="flex w-full items-start justify-start ">
                  {product?.care_tip || (
                    <div className="flex flex-col gap-2 items-start justify-start">
                      <p className="text-xl lg:text-2xl font-semibold">
                        {i18n.language === "en"
                          ? "Trim the Stems:"
                          : "قص السيقان:"}
                      </p>
                      <p className="text-base lg:text-lg">
                        {i18n.language === "en"
                          ? "Cut 2 cm from the bottom of the stems at a 45° angle before placing them in water to ensure better water absorption."
                          : "اقطع 2 سم من أسفل السيقان بزاوية 45 درجة قبل وضعها في الماء لضمان امتصاص أفضل للماء."}
                      </p>

                      <p className="text-xl lg:text-2xl font-semibold">
                        {i18n.language === "en"
                          ? "Remove Lower Leaves:"
                          : "إزالة الأوراق السفلية:"}
                      </p>
                      <p className="text-base lg:text-lg">
                        {i18n.language === "en"
                          ? "Remove any leaves below the water level to prevent bacterial growth and rotting."
                          : "قم بإزالة أي أوراق تقع أسفل مستوى الماء لتجنب نمو البكتيريا والتعفن."}
                      </p>

                      <p className="text-xl lg:text-2xl font-semibold">
                        {i18n.language === "en"
                          ? "Use Clean Water:"
                          : "استخدام ماء نظيف:"}
                      </p>
                      <p className="text-base lg:text-lg">
                        {i18n.language === "en"
                          ? "Fill the vase with cold, fresh water, and add a teaspoon of sugar or a flower food packet to nourish the flowers."
                          : "املأ الإناء بماء بارد ونظيف، وأضف ملعقة صغيرة من السكر أو كيس غذاء الزهور لتغذية الزهور."}
                      </p>

                      <p className="text-xl lg:text-2xl font-semibold">
                        {i18n.language === "en"
                          ? "Change Water Regularly:"
                          : "تغيير الماء بانتظام:"}
                      </p>
                      <p className="text-base lg:text-lg">
                        {i18n.language === "en"
                          ? "Replace the water daily and clean the vase to maintain freshness and avoid bacteria buildup."
                          : "قم باستبدال الماء يوميًا ونظف الإناء للحفاظ على نضارة الزهور وتجنب تراكم البكتيريا."}
                      </p>

                      <p className="text-xl lg:text-2xl font-semibold">
                        {i18n.language === "en"
                          ? "Place in a Cool Spot:"
                          : "وضع الإناء في مكان بارد:"}
                      </p>
                      <p className="text-base lg:text-lg">
                        {i18n.language === "en"
                          ? "Keep the vase away from direct sunlight, heat sources, and drafts to prolong the life of your flowers."
                          : "ضع الإناء بعيدًا عن أشعة الشمس المباشرة ومصادر الحرارة والتيارات الهوائية لإطالة عمر الزهور."}
                      </p>
                    </div>
                  )}
                </div>
              ) : (
                <div className="flex items-start justify-start w-full ">
                  {i18n.language === "en"
                    ? product?.english_description
                    : product?.arabic_description}
                </div>
              )}
            </div>
            <div
              className="flex flex-col items-center justify-center gap-2 w-full 
      relative mt-20"
            >
              <p className="text-3xl lg:text-4xl">{t("relatedProducts")}</p>
            </div>
            <RelatedProducts categoryId={product?.category_id} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Product;
